import React from "react";
import { useTranslation } from "react-i18next";

export interface StatsItemProps {
    readonly label: string;
    readonly value: number;
}

// tslint:disable-next-line:no-var-requires
const style = require("./StatsItem.scss");

export default function StatsItem({ label, value }: StatsItemProps) {
    const { t } = useTranslation("cashout");
    return (
        <div className={style.panel}>
            <div className={style.statsValue}>{value.toFixed(2)} €</div>
            <div className={style.statsLabel}>{t(label)}</div>
        </div>
    );
}
